<template>

  <div class="admin-dashboard-Filters flex mt-3">

    <div class="w-full flex mb-4 flex-wrap xl:flex-no-wrap">

      <div
              class="w-1/2 mr-4 mb-2 relative">
        <v-select
            v-model="selectedRoomNames"
            placeholder="Alle kamers"
            :options="roomNames"
            :multiple="true"
        >
          <div slot="no-options">Geen resultaten</div>
        </v-select>
      </div>

      <div class="w-1/2 mr-4 mb-2 relative">
        <v-select
            v-model="selectedUsers"
            placeholder="Alle gebruikers"
            :options="users"
            :multiple="true"
            @input="usersInput"
        >
          <div slot="no-options">Geen resultaten</div>
        </v-select>
      </div>

      <date-range-picker
              class="w-1/2 mr-4 mb-2"
              ref="picker"
              v-model="dateRange"
			  :timePicker="true"
			  :timePicker24Hour="true"
              :showDropdowns="true"
              :minDate="minDatepickerDate"
              :maxDate="maxDatepickerDate"
              :ranges="ranges"
              :localeData="{
				  direction: 'ltr',
				  format: 'dd-mm-yyyy',
				  applyLabel: 'Toepassen',
				  cancelLabel: 'Annuleren',
				  fromLabel: 'Van',
				  toLabel: 'Tot',
				  customRangeLabel: 'Afwijkend',
				  daysOfWeek: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
				  monthNames: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
				  firstDay: 1,
			  }"
      />

      <div class="w-1/2 mr-4 mb-2">

        <button type="button" class="btn btn-primary" :disabled="exportLoading" @click="downloadExport">
          <i class="fa mr-1"
             :class="{
                'fa-download': !exportLoading,
                'fa-circle-notch fa-spin': exportLoading
             }"
          />
          {{ exportText }}
        </button>

      </div>

    </div>

  </div>

</template>

<script>

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Api from './api'
import {filterStore, filterMutations} from "./filterStore";
import moment from "moment";
export default {
  name: 'filters',
  components: {
    'v-select': vSelect,
    'date-range-picker': DateRangePicker,
  },

  props: {},

  data: function () {
    return {
      exportLoading: false,

      // selected: null,
      // options: [],

      // For some reason, the min Date can't be a Date object
      minDatepickerDate: null,

      // These roomnames can be selected in the filter
      roomNames: [],

      // These users can be selected in the filter
      users: [],

    }
  },

  async created() {
    // Set the datepicker min and max dates
    this.minDatepickerDate = new Date(await Api.getInfo());

    // Subtract one day to fix displaying the min date as 1 day too many
    this.minDatepickerDate.setDate(this.minDatepickerDate.getDate() - 1);

    // Get all the roomNames
    this.roomNames = await Api.getRoomNames()

    // Get all the users
    // TODO: set the ids and names in v-select, so we're able to filter in the backend
    this.users = await Api.getUsers()
  },

  methods: {
    usersInput(value) {

    },

    async downloadExport() {
		  this.exportLoading = true;

      let queryString = Api.buildQueryString();

      let response = await fetch('/admin/notifications/export' + queryString)
      let json = await response.json()
      let filename = json['filename']

      // When we have a filename, start polling the storage
      let pdfIsAvailable = false;

      // Poll the server every 2 seconds: stop polling when the file is available
      while(!pdfIsAvailable)
      {
        let pdfAvailableResponse = await fetch('/admin/notifications/export/pdfavailable?filename=' + filename)
        let pdfJson = await pdfAvailableResponse.json()
        pdfIsAvailable = pdfJson['available'] == 'true'

        // Wait 2 seconds
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }

      // Download the file
      window.location.href = '/admin/notifications/export/downloadpdf?filename=' + filename

      this.exportLoading = false;
    }

  },

  computed: {
    dateRange: {
      get: () => filterStore.dateRange,
      set: (dateRange) => filterMutations.setDateRange(dateRange)
    },

    selectedRoomNames: {
      get: () => filterStore.selectedRoomNames,
      set: (roomNames) => filterMutations.setSelectedRoomNames(roomNames)
    },

    selectedUsers: {
      get: () => filterStore.selectedUsers,
      set: (users) => filterMutations.setSelectedUsers(users)
    },

    maxDatepickerDate: () => new Date(),

    ranges() {
      return {
        'Vandaag': [moment().toDate(), moment().toDate()],
        'Gisteren': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
        'Laatste 7 dagen': [moment().subtract(6, 'days').toDate(), moment().toDate()],
        'Laatste 30 dagen': [moment().subtract(29, 'days').toDate(), moment().toDate()],
        'Deze maand': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
        'Laatste maand': [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]
      };
    },

    exportText()
    {
      return this.exportLoading ? 'Exporteren...' : 'Exporteer'
    }


  },

  watch: {},
}
</script>

<style lang="scss">

.admin-dashboard-Filters {

  .vue-daterange-picker {
    min-width: 250px;

    .form-control {
      display:     block !important;
      padding-top: 7px;

      i.fa-calendar {
        margin-right: 5px;
      }
    }

    .dropdown-menu {
      margin-top: -60px;
    }
  }

  .v-select {
    min-width: 244px;

    .vs__dropdown-toggle {
      background: white;
      min-height: 38px;
    }

    .vs__actions {
      cursor: pointer;
    }
  }
}

</style>
